export default __webpack_public_path__ + "static/aurora-ca9b4ff9828cab6ecf11e64525a39e7a.jpeg";